// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const emptyArray = Object.freeze([]) as readonly any[];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const emptyObject = Object.freeze({}) as Readonly<Record<string, any>>;

/* Use when you need a strongly typed empty array, for example:
   emptyArrayOf<SupplierProduct>() or emptyArrayOf<number>() */
export function emptyArrayOf<T>(): T[] {
  return emptyArray as unknown as T[];
}
